/**
 * Resolve public/ asset URLs for @xt/Nav.
 * Mirrors ssr-web-index `src/utils/publicSvgUrl.js` / `_app.js` CDN convention:
 * production serves static files at `{NEXT_PUBLIC_cdn}/public/...`.
 *
 * @param {string} relativePath — e.g. `brand/logo-mark.png` or `/brand/logo-mark.png`
 */
export function navPublicAssetUrl(relativePath) {
  const rel = `/${String(relativePath || "").replace(/^\/+/, "")}`;
  if (process.env.NEXT_PUBLIC_DEV) return rel;
  const cdn = process.env.NEXT_PUBLIC_cdn;
  if (cdn) return `${cdn}/public${rel}`;
  return rel;
}
